import { ReactComponent as CheckedComp } from '@/images/CheckedComp.svg';
import { ReactComponent as CheckedCompV2 } from '@/images/CheckedCompv2.svg';
import UnCheckedCompV2Png from '@/images/UnCheckedCompv2.png';
import { Checkbox } from 'rc-ui-lib';
import type { CheckboxProps } from 'rc-ui-lib/lib/checkbox';
import { useMemo } from 'react';
import style from './index.module.less';

function UnCheckBox(props: CheckboxProps & { clsName?: string }) {
  const { iconSize, clsName } = props;
  return (
    <div
      style={{
        width: iconSize,
        height: iconSize,
      }}
      className={`${style.uncheck} ${clsName}`}
    />
  );
}

function VCreditCheckbox(props: CheckboxProps & { clsName?: string; uiV2?: boolean }) {
  const { iconSize, clsName, uiV2 } = props;
  const checkedEle = useMemo(() => {
    let Component = CheckedComp;
    if (uiV2) {
      Component = CheckedCompV2;
    }
    return (
      <Component
        {...props}
        className={`${clsName}`}
        style={{
          width: iconSize,
          height: iconSize,
        }}
      />
    );
  }, [iconSize, uiV2]);
  const unCheckdEle = useMemo(() => {
    if (uiV2) {
      return (
        <img
          src={UnCheckedCompV2Png}
          alt=""
          style={{
            width: iconSize,
            height: iconSize,
          }}
        />
      );
    }
    return (
      <UnCheckBox
        {...props}
        iconSize={iconSize}
        style={{
          width: iconSize,
          height: iconSize,
          minWidth: uiV2 ? 'fit-content' : undefined,
        }}
      />
    );
  }, [iconSize, uiV2]);

  return (
    <Checkbox
      {...props}
      iconRender={({ checked }) => {
        if (checked) {
          return checkedEle;
        }
        return unCheckdEle;
      }}
    />
  );
}

export default VCreditCheckbox;
